<template>
        <footer id="footer">
            <div class="footer-holder">
                <div class="footer-frame">
                    <div class="footer-content">
                        <div class="col-holder">
                            <div class="col_wrap">
                                <div class="col">
                                    <h3>Liên hệ</h3>
                                    <address class="map">122, Phan Đình Phùng, TP. Hồng Ngự, Đồng Tháp</address>
                                    <!-- <address class="mail"><a href="mailto:contact@kidschool.com">contact@kidschool.com</a></address> -->
                                    <address class="phone"><a href="tel:0385259009">0385259009</a>  (cô Trí)</address>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="footer-bottom">
                        <div class="holder">
                            <p>&copy; 2020 dayorgan.club</p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>    
</template>

<script>
export default {
    
}
</script>

<style scoped>

</style>
